import { computed, type ComputedRef } from 'vue'
import { useRouter } from 'vue-router'
import { ROUTE_QUESTIONNAIRE } from '@/router'

export const useRouterTransition = (): {
    transitionMode: ComputedRef<'in-out' | 'out-in' | 'default'>
    transitionName: ComputedRef<string>
} => {
    const router = useRouter()

    // Special cases handled here
    // Here we can override the transition of the next route
    // TODO: probably can be done with additional meta fields + watch currentRoute
    router.afterEach((to, from) => {
        if (to.name === ROUTE_QUESTIONNAIRE) {
            to.meta['transitionName'] = 'fullscreen-modal-start'
            to.meta['transitionMode'] = 'default'
        } else if (from.name === ROUTE_QUESTIONNAIRE) {
            to.meta['transitionName'] = 'fullscreen-modal-end'
            to.meta['transitionMode'] = 'default'
        }
    })

    const transitionMode = computed(() => {
        const mode = router.currentRoute.value.meta['transitionMode']

        return mode || 'out-in'
    })

    const transitionName = computed(() => {
        const name = router.currentRoute.value.meta['transitionName']

        return name || 'fade-route'
    })

    return {
        transitionMode,
        transitionName,
    }
}
